export default __webpack_public_path__ + "static/media/wine_bar_black_24dp.338e4184.svg";